import { render, staticRenderFns } from "./scoreInfoModal.vue?vue&type=template&id=7bfb84fc&scoped=true&"
import script from "./scoreInfoModal.vue?vue&type=script&lang=js&"
export * from "./scoreInfoModal.vue?vue&type=script&lang=js&"
import style0 from "./scoreInfoModal.vue?vue&type=style&index=0&id=7bfb84fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bfb84fc",
  null
  
)

export default component.exports